import React from 'react';

type ConfirmLeaveModalProps = {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string; // Save and leave
  discardText?: string; // Discard and leave
  onConfirm: () => void;
  onDiscard: () => void;
  onClose: () => void; // Stay on page
  busy?: boolean;
};

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const modalStyle: React.CSSProperties = {
  background: '#fff',
  borderRadius: 12,
  width: 420,
  maxWidth: '90vw',
  boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
  overflow: 'hidden',
};

const headerStyle: React.CSSProperties = {
  padding: '16px 20px',
  fontWeight: 600,
  fontSize: 16,
  borderBottom: '1px solid #eee',
};

const bodyStyle: React.CSSProperties = {
  padding: '16px 20px',
  color: '#444',
  lineHeight: 1.6,
};

const footerStyle: React.CSSProperties = {
  display: 'flex',
  gap: 12,
  justifyContent: 'flex-end',
  padding: '14px 20px',
  borderTop: '1px solid #eee',
};

const buttonBase: React.CSSProperties = {
  padding: '8px 14px',
  borderRadius: 8,
  border: '1px solid transparent',
  cursor: 'pointer',
  fontSize: 14,
};

const secondaryBtn: React.CSSProperties = {
  ...buttonBase,
  background: '#f3f4f6',
  color: '#111827',
};

const dangerBtn: React.CSSProperties = {
  ...buttonBase,
  background: '#fff',
  color: '#ef4444',
  border: '1px solid #ef4444',
};

const primaryBtn: React.CSSProperties = {
  ...buttonBase,
  background: '#8b5cf6',
  color: 'white',
};

const ConfirmLeaveModal: React.FC<ConfirmLeaveModalProps> = ({
  open,
  title = 'Unsaved changes',
  message = 'You have unsaved changes. Do you want to save before leaving?',
  confirmText = 'Save and leave',
  discardText = 'Discard and leave',
  onConfirm,
  onDiscard,
  onClose,
  busy = false,
}) => {
  if (!open) return null;

  return (
    <div style={overlayStyle} role='dialog' aria-modal='true'>
      <div style={modalStyle}>
        <div style={headerStyle}>{title}</div>
        <div style={bodyStyle}>{message}</div>
        <div style={footerStyle}>
          <button
            type='button'
            style={secondaryBtn}
            onClick={onClose}
            disabled={busy}
          >
            Stay on page
          </button>
          <button
            type='button'
            style={dangerBtn}
            onClick={onDiscard}
            disabled={busy}
          >
            {discardText}
          </button>
          <button
            type='button'
            style={primaryBtn}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Saving…' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmLeaveModal;


